export default __webpack_public_path__ + "static/media/texture.c1872169.svg";